import { render } from "./DevicesWrapper.vue?vue&type=template&id=96c248e0"
import script from "./DevicesWrapper.vue?vue&type=script&lang=js"
export * from "./DevicesWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__